<template>
    <div class="FileList">
              <ul>
                <li v-for="(item,index) in dataList" :key='item.ID' class=" fadeInUp" :data-wow-delay="index/5+'s'">
                     <router-link  :to="item.Url" :href="item.Url"  @click.native="OpenLink(item.Url)"  >
                        <div  class="imgBox"> <img :src="item.Cover" /></div>
                        <div class="textBox">
                          <p class="title txt-cut1" :title="item.Title" >{{item.Title}}</p>
                        </div>
                      </router-link>
                </li>
             </ul>
             <!-- <div v-if="moreLink" class="more wow zoomIn" data-wow-delay="0.3s"><router-link :to="moreLink" ><em>查看更多</em></router-link></div> -->
    </div>
</template>
<script>
export default {
  name: 'fileList',
  props: {
     dataList: { // 图片列表
      type: Array,
      default: () => []
     },
     dataType: {
       type: String,
       default: 'img'
     },
     moreLink: {
       type: String,
       default: ''
     },
    styles: { 
      type: Object,
      default: () => {
        return {
          width: 1920,
          height: 500
        }
      }
    }
  },
   data () {
     return {
        showItem: this.dataList? this.dataList[0]:null
     }
   },
  methods:{
        setTimeformat(_data,_format='yyyy-mm-dd'){
            // console.log(_data)
             return _format.replace(/YYYY/i,_data.substr(0,4)).replace(/MM/i,_data.substr(5,2)).replace(/DD/i,_data.substr(8,2))
        }
   }
}
</script>
<style lang="less" scoped >
// $themeColor
  .FileList{
      ul{
          font-size: 0;
          width: 7.5rem;
          // margin-top: -20rem;
          // margin-bottom: 25px ;
        li{
           margin-right: 0.38rem;
          &:nth-child(even){
            margin-right: 0px;
          }
            box-sizing: border-box;
            width: 3.26rem;
            min-height: 2.4rem;
            position: relative;
            font-size:0;
          
            display:  inline-block;
            vertical-align: top;
            // background: #fff;
            margin-top:0.2rem;
            margin-bottom:10px;
            .imgBox{
                display: inline-block;
                width: 100%;
                height: 2rem;
                vertical-align: top;
                img{
                  max-width: 100%;
                }
            }
            .textBox{
                box-sizing: border-box;
                background: #EBEBEB;
            .title{
                font-size: 0.26rem;

                color: #333;
                padding-top: 0.25rem;
                line-height: 1;
                text-align: center;
                padding-bottom: 0.2rem;
                position: relative;
                &::before{
                  content: "";
                  display: block;
                  position: absolute;
                  left: 50%;
                  top: 0.13rem;
                  margin-left: -0.25rem;
                  width: 0.5rem;
                  height: 0.02rem;
                  background: #0376be;

                }
              
            }
            // .text{
            //      font-size: 16px;
            //      color: #666;
            //      line-height: 1.5;
            // }
           
            
          }
        }
      }

  }

</style>


// WEBPACK FOOTER //
// src/components/ImgTextList.vue